export default __webpack_public_path__ + "static/other-services-3e1fa21e2dbea267c3a102a51acab54a.png";